import { format, parseISO } from "date-fns";
export function removePhoneMask(value) {
    if (!value)
        return "";
    var cleanedValue = value.replace(/\D/g, "");
    return "+55".concat(cleanedValue);
}
export function removeCepMask(value) {
    if (!value)
        return "";
    var cleanedValue = value.replace(/\D/g, "");
    return cleanedValue;
}
export function removeDateMask(value) {
    if (!value)
        return "";
    var splittedValue = value.split("/");
    var joinedValue = splittedValue.join("");
    var formattedValue = joinedValue.replace(/(\d{2})(\d{2})(\d{4})/, "$3-$2-$1");
    return formattedValue;
}
export function removeCpfMask(value) {
    if (!value)
        return "";
    var cleanedValue = value.replace(/\D/g, "");
    return cleanedValue;
}
export function formatDateFromAPI(value) {
    var parsedDate = parseISO(value);
    return "".concat(format(parsedDate, "dd/MM/yyyy"), " ").concat(format(parsedDate, "HH"), ":").concat(format(parsedDate, "mm"));
}
export function formatGender(value) {
    if (!value)
        return "";
    var genderMap = {
        M: "Masculino",
        F: "Feminino",
    };
    return genderMap[value];
}
export function formatSex(value) {
    if (!value)
        return "";
    var sexMap = {
        M: "Masculino",
        F: "Feminino",
        O: "Outro",
        PNI: "Prefiro não informar",
    };
    return sexMap[value];
}
export function formatCategory(value) {
    if (!value)
        return "";
    var categoryMap = {
        INFANTIL: "12 a 14 anos - Infantil",
        INFANTO: "15 a 17 anos - Infanto",
    };
    return categoryMap[value];
}
